// 订单管理
export default [{ // 订单管理
  path: '/orderManager',
  name: 'orderManager',
  component: resolve => require(['@/views/orderManager/orderManager.vue'], resolve),
  meta: {
    group: "/orderManager",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 订单新增
  path: '/addOrder',
  name: 'addOrder',
  component: resolve => require(['@/views/orderManager/addOrder.vue'], resolve),
  meta: {
    group: "/orderManager",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 订单编辑
  path: '/editOrder',
  name: 'editOrder',
  component: resolve => require(['@/views/orderManager/addOrder.vue'], resolve),
  meta: {
    group: "/orderManager",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 订单查看
  path: '/viewOrder',
  name: 'viewOrder',
  component: resolve => require(['@/views/orderManager/addOrder.vue'], resolve),
  meta: {
    group: "/orderManager",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 订单审核
  path: '/processOrder',
  name: 'processOrder',
  component: resolve => require(['@/views/orderManager/addOrder.vue'], resolve),
  meta: {
    group: "/orderManager",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}]


// WEBPACK FOOTER //
// ./src/router/orderManager/orderManager.js